import { render, staticRenderFns } from "./TabAssets.vue?vue&type=template&id=4b7964ca"
import script from "./TabAssets.vue?vue&type=script&lang=ts"
export * from "./TabAssets.vue?vue&type=script&lang=ts"
import style0 from "./TabAssets.vue?vue&type=style&index=0&id=4b7964ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports